export default "__VITE_ASSET__L1CZS0Yt__"